import React, { useEffect, useState } from "react";
import { Card, Spin, Empty, Tag } from "antd";
import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";
import "./DashboardStats.scss";

const initials = (name) =>
  (name || "?")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();
const empName = (r) =>
  [r.employee?.firstName, r.employee?.lastName].filter(Boolean).join(" ") ||
  r.employee?.fullName ||
  r.employeeName ||
  "Employee";
const deptName = (r) =>
  r.employee?.departmentName || r.departmentName || r.department?.name || "";
const fmtShort = (d) =>
  d ? new Date(d).toLocaleDateString("en-US", { month: "short", day: "numeric" }) : "";

// Employees currently on approved leave (today within from..to).
const DashboardOnLeave = () => {
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const r = await axiosInstance.get(API.leaveRequest.getAll);
        const list = Array.isArray(r.data) ? r.data : r.data?.data || [];
        const today = new Date();
        today.setHours(12, 0, 0, 0);
        const onLeave = list.filter((lr) => {
          const approved = lr.status === 1 || lr.status === "Approved";
          if (!approved || !lr.fromDate || !lr.toDate) return false;
          const from = new Date(lr.fromDate);
          const to = new Date(lr.toDate);
          from.setHours(0, 0, 0, 0);
          to.setHours(23, 59, 59, 999);
          return from <= today && today <= to;
        });
        if (active) setRows(onLeave);
      } catch (e) {
        if (active) setRows([]);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  return (
    <Card title="On Leave Today" className="dash-card">
      {loading ? (
        <div style={{ textAlign: "center", padding: 30 }}>
          <Spin />
        </div>
      ) : rows.length === 0 ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No one is on leave today" />
      ) : (
        rows.map((r, i) => (
          <div
            key={i}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              padding: "8px 0",
              borderBottom: "1px solid #f5f5f5",
            }}
          >
            <div
              style={{
                width: 38,
                height: 38,
                borderRadius: "50%",
                background: "#E8F5E9",
                color: "#2E7D32",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 600,
                fontSize: 13,
                flexShrink: 0,
              }}
            >
              {initials(empName(r))}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 500, color: "#1f2937" }}>{empName(r)}</div>
              <div style={{ fontSize: 12, color: "#888" }}>{deptName(r)}</div>
            </div>
            <Tag color="orange">until {fmtShort(r.toDate)}</Tag>
          </div>
        ))
      )}
    </Card>
  );
};

export default DashboardOnLeave;
